import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { GrChannel } from "react-icons/gr";
import Logo from '../assets/logo.png';
import { MdDashboard, MdFormatListBulleted, MdSubscriptions } from 'react-icons/md';
import { FaAngleLeft, FaAngleRight, FaUserFriends } from 'react-icons/fa';
import { IoLink, IoNewspaper, IoPower } from 'react-icons/io5';
import { FaCogs } from "react-icons/fa";
import { FaChartSimple } from 'react-icons/fa6';

const Sidebar = () => {
        const [collapsed, setCollapsed] = useState(false);
    const navigate = useNavigate();
    const [showLogout, setShowLogout] = useState(false);


            const toggleSidebar = () => {
        setCollapsed(!collapsed);
    };


    const handleLogout = () => {
        localStorage.removeItem('userData');
        navigate('/admin-login');
        window.location.reload();
    }


  return (
    <>
                  <div className={`sidebar-area ${collapsed ? "" : "collapsed"}`}>

                <span className="sidebar-item py-2 px-2" onClick={toggleSidebar}>
                    {collapsed ? <FaAngleLeft size={22} /> : <FaAngleRight size={22} />}
                </span>

                <div className='text-center'>
                    <img src={Logo} className='sidebar-logo' alt='Logo Sidebar' />
<p className='sidebar-menu-title fm-inter fw-semibold text-light'>Trade <span className='fw-bolder'>Intell</span></p>
                </div>

                    <div className='mt-4'>
                        <p className='sidebar-menu-title'>MENU</p>
                        <p className='sidebar-item' onClick={() => { navigate('/'); setCollapsed(false) }}><MdDashboard size={22} /><Link className='sidebar-text'>Dashboard</Link></p>
                        <p className='sidebar-item' onClick={() => { navigate('/manage-profile  '); setCollapsed(false) }}><FaCogs size={22} /><Link className='sidebar-text'>Manage Profile</Link></p>
                        <p className='sidebar-item' onClick={() => { navigate('/view-users'); setCollapsed(false) }}><FaUserFriends size={22} /><Link className='sidebar-text'>View Users</Link></p>
                                            <p className='sidebar-item' onClick={() => { navigate('/subscriptions'); setCollapsed(false) }}><MdSubscriptions size={22} /><Link className='sidebar-text'>Subscription Plan</Link></p>

                    <p className='sidebar-item' onClick={() => { navigate('/educational-links'); setCollapsed(false) }}><IoLink size={22} /><Link className='sidebar-text'>Edu Links</Link></p>
                    <p className='sidebar-item' onClick={() => { navigate('/my-insights'); setCollapsed(false) }}><FaChartSimple size={22} /><Link className='sidebar-text'>My Insights</Link></p>
                    <p className='sidebar-item' onClick={() => { navigate('/news'); setCollapsed(false) }}><IoNewspaper size={22} /><Link className='sidebar-text'>News & Media</Link></p>
                    <p className='sidebar-item' onClick={() => { navigate('/channel-list'); setCollapsed(false) }}><GrChannel size={22} /><Link className='sidebar-text'>Channels</Link></p>
                    <p className='sidebar-item' onClick={() => { navigate('/site-enquiry'); setCollapsed(false) }}><MdFormatListBulleted size={22} /><Link className='sidebar-text'>Site Enquiry</Link></p>
                        <p className='sidebar-item' onClick={() => { setShowLogout(true) }}><IoPower size={22} /><Link className='sidebar-text'>Log Out</Link></p>
</div>

                <span className="sidebar-btn py-2"
                 onClick={toggleSidebar}>
                    {collapsed ? <FaAngleLeft size={22} /> : <FaAngleRight size={22} />}
                </span>
</div>

                            {showLogout && (
                <section className='detail-dialog p-2' onClick={() => setShowLogout(false)}>
                    <div className='detail-dialog-inner col-lg-5 animate__animated animate__zoomIn rounded mx-auto px-lg-5 py-lg-5 px-3 py-3 text-center' onClick={(e) => e.stopPropagation()}>

                        <p className='sidebar-menu-title text-dark fs-6'>Log Out your Account!</p>

                        <button className='btn-style1' onClick={() => handleLogout()}>Yes</button>&nbsp;&nbsp;
                        <button className='btn-style2' onClick={() => setShowLogout(false)}>No</button>

                    </div>
                </section>
            )}
    </>
  )
}

export default Sidebar